<div class="form-field">
  <tpm-icon [icon]="icon" class="form-field__icon"></tpm-icon>
  <input
    class="form-field__input body-sm"
    type="text"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [ngModel]="model"
    [ngModelOptions]="{ name, standalone: true }"
    (ngModelChange)="update.emit($event)"
  />
</div>
